import styled from 'styled-components';
import Tabs from 'components/Tabs';
import Tab from 'components/Tab';
import Icon from './Icon';

const Header = () => {
  return (
    <HeaderWrapper>
      <Icon source='lizzy' name='lizzy-logo-colored-text' className='logo' />

      <TabsWrapper>
        <Tab href='/'>Clean</Tab>
        <Tab href='/contract'>Contract</Tab>
      </TabsWrapper>
    </HeaderWrapper>
  );
}

export default Header;

const HeaderWrapper = styled.header`
  background-color: var(--lizzy-white);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr; /* 1 row */
  justify-items: center;

  .logo {
    width: 258px;
    height: 52px;
    place-self: center;
    justify-self: start;
  }
`;

const TabsWrapper = styled(Tabs)`
  grid-column: 2 / 3;
`;